module.exports = __webpack_public_path__ + "static/p4-8253e09b8476e994278997989c2a5cff.jpg";